import { useState } from 'react';
import { useQueries } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { CircularProgress } from '@mui/material';
import styled from '@emotion/styled';
import Header from '../../../../customs/Header'
import SettingsModal from '../Modal/settingsCustomModal';
import CreateState from './CreateState';
import { FilterDropDown } from '../../../../ui-components';
import StateTable from './Table';
import apiCall from '../../../../utils/apiCall';
import styles from '../../Applicants/css/display-applicant.module.css';
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';
import {IoReload as ReloadIcon} from 'react-icons/io5';


interface Country {
  CountryId: number;
  CountryName: string;
}

interface CountryResponse {
  data: Country[];
}

interface State {
  StateId: number;
  StateName: string;
  CountryId?: number;
  Country: CountryByState;
}

interface CountryByState {
  CountryId: number;
  CountryName: string;
  Id: number;
  CreatedBy?: any;
  ModifiedBy?: any;
  UserIpAddress?: any;
  CreateDate: string;
  LastModified: string;
  ActiveStatus: boolean;
  IsApprovalRequired?: any;
  RouteId?: any;
  ApprovalTypeId?: any;
  IsDeleted: boolean;
}

export default function Main() {
  const [createState, setCreateState] = useState(false);
  const [country, setCountry] = useState({val: '0', name: ''});
  const [searchData, setSearchData] = useState('')
  
  const handleOpenCreateState = () => setCreateState(true);
  const handleCloseCreateState = () => setCreateState(false);

  const countryId = country ? country?.val : '';

  const getCountries = async (): Promise<CountryResponse> => {
    return (await apiCall().get('/Country/GetCountrys')); 
  };

  const getStatesByCountry = async (): Promise<State[]> => {
    return (await apiCall().get(`/State/GetStateByContry/${countryId}`)).data;
  };

  const getStates = async (): Promise<State[]> => {
    return (await apiCall().get('/State/GetAllStates')).data;
  };

  const [getCountriesQuery, getStatesByCountryQuery, getStatesQuery] = useQueries(
    {
      queries: [
        {queryKey: ['get-countries'], queryFn: getCountries, },
        {queryKey: ['get-states-by-country', countryId, searchData], queryFn: getStatesByCountry},
        {queryKey: ['get-states'], queryFn: getStates, enabled: true},
      ]
    }
  );

  const getCountryMessage = getCountriesQuery?.error as AxiosError;
  const getCountryErrorMessage = getCountryMessage?.message;

  const getStateMessage = getStatesQuery.error as AxiosError;
  const getStateErrorMessage = getStateMessage?.message;

  const getStateByCountryMessage = getStatesByCountryQuery.error as AxiosError;
  const getStateByCountryErrorMessage = getStateByCountryMessage?.message;

  const mappedCountry: any[] | undefined = getCountriesQuery?.data && getCountriesQuery?.data?.data.map((item) => {
    let country = {
      val: item?.CountryId,
      name: item?.CountryName,
    }
    return country;
  });

  const filteredState = getStatesQuery?.data && getStatesQuery?.data.filter((data1: any) => {
    return countryId === '0' ? data1 : getStatesByCountryQuery?.data?.some((data2: any) => {
      return data1?.CountryId === data2?.CountryId;
    })
  });

  const filteredData = filteredState?.filter(x => (
    Object.values(x).join(" ").toLowerCase().includes(searchData.toLowerCase())
  ));
  
  return (
    <section>
      <Header props = {
        { 
          firstName: 'All', 
          secondName: 'State', 
          buttonText: 'Create State', 
        }}
        handleOpen={handleOpenCreateState}
      />

      <InnerContainer >
        <label className={styles.searchForm} >
          <span className={styles.sI}><SearchIcon/></span>
          <input value = {searchData} onChange={(e) => setSearchData(e.target.value)} type="text" placeholder='Search' />
          <button className={styles.rBtn} type="submit">
            <ReloadIcon/>
          </button>
        </label>
        <FilterDropDown onChange={setCountry} options={mappedCountry} text="Country" bg="#11643C" color="#fff" replace={'true'}/>
      </InnerContainer>
      <StyledContainer>
        {getStatesByCountryQuery?.isFetching ? (
          <CircularProgress
            sx={{
              fontSize: '1rem',
              marginInline: 'auto',
              display: 'block',
              marginBlock: '2rem'
            }} 
          />
          ) : (countryId === '0' ? getStatesQuery?.isError : getStatesByCountryQuery?.isError) ? (
            <StyledError>{countryId === '0' ? getStateByCountryErrorMessage : getStateErrorMessage}</StyledError>
          ) :  filteredData && filteredData?.length > 0 ?  (
          <StateTable 
            getStatesQuery={searchData.length > 0 ? filteredData : filteredState}
            getCountryData={getCountriesQuery?.data}
            countryIsError={getCountriesQuery?.isError}
            countryIsLoading={getCountriesQuery?.isLoading}
            getCountryErrorMessage={getCountryErrorMessage}
          />
        ) : <NoResult>No Results</NoResult>}
      </StyledContainer>
      
      <SettingsModal 
        open={createState}
        cancel={handleCloseCreateState}
        maxWidth='480px'
        header={'Create State'}
        showrightIcon={false}
        content={
          <CreateState 
            handleClose={handleCloseCreateState}
            data={getCountriesQuery?.data}
            isLoading={getCountriesQuery.isLoading}
            isError={getCountriesQuery?.isError}
            getCountryErrorMessage={getCountryErrorMessage}
          />
        }
      />
    </section>
    
  )
};

const InnerContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
  margin-inline-start: 48px;
`

const StyledContainer = styled.div`
    margin-block: 3.8rem;
    margin-inline: 3.5rem;
`

const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`

const NoResult = styled('div')`
  margin-block-start: 0px;
`


